export default class MapBox {
    coordinates = null;
    zoom = 10;
    isSingleLocation = true;
    map = null;

    constructor(coordinates, zoom) {
        console.log('coords', coordinates);
        // coordinates with be like either
        // { latitude: 123, longitude: 123 }
        // or
        // [{ latitude: 123, longitude: 123 }, { latitude: 123, longitude: 123 }]

        // convert either to
        // [[123, 123], [123, 123]]

        if (!Array.isArray(coordinates)) {
            this.isSingleLocation = true;
            this.coordinates = [{"lng": coordinates.longitude, "lat": coordinates.latitude}];
        } else {
            this.isSingleLocation = false;
            this.coordinates = coordinates.map(coord => [{"lng": coord.longitude, "lat":coord.latitude}]);
        }

        if (zoom) {
            this.zoom = zoom;
        }
    }

    init() {
        this.initMap();

        window.addEventListener("resizemap", () => {
            this.mapResize();
        });

    }

    initMap () {
        // get this from settings
        mapboxgl.accessToken = 'pk.eyJ1IjoiamFtZXMtcG5wIiwiYSI6Ikc0bVhFckUifQ.wn99C0bWhKeMSOqHCQ8Akg';

        // this is example data
        // const lineJson = { features : [ { type : 'Feature', geometry : { type : 'LineString', coordinates : [ [ -58.53482839975321, -34.81500440037828 ], [ -58.4268324530276, -34.5876824396606 ], [ -65.501080744056, -23.7444561846391 ], [ -65.9468984895145, -23.6631700805861 ], [ -66.1777707967173, -25.1105481703966 ], [ -66.0024010879306, -26.0762411882646 ], [ -67.265969628686, -26.4779781175378 ], [ -67.3962068100293, -24.5895972932487 ], [ -65.5409279362862, -24.8561651002507 ], [ -58.53482839975321, -34.81500440037828 ] ] } } ] };
        // const coordinates = lineJson.features[0].geometry.coordinates;

        console.log('coords latlng', this.coordinates[0]);

        let bounds = this.coordinates.reduce(function(bounds, coord) {
            return bounds.extend(coord);
        }, new mapboxgl.LngLatBounds(this.coordinates[0], this.coordinates[0]));

        for (const coord of this.coordinates) {
            bounds.extend(coord);
        }

        const mapSettings = {
            container: 'mapbox',
            style: 'mapbox://styles/james-pnp/cjui3pknm2kn81ftitqboac27',
            interactive: true,
            scrollZoom: true,
            dragRotate: false,
            boxZoom: false,
            dragPan: true, 
            keyboard: {
                enabled: true,
            },
            cooperativeGestures: false,
            attributionControl: false,
            zoom: this.zoom,
        };

        if (this.isSingleLocation) {
            mapSettings.center = this.coordinates[0];
        } else {
            mapSettings.bounds = bounds;
        }
        
        this.map = new mapboxgl.Map(mapSettings);
        
        if(this.isSingleLocation){
            const stm = document.createElement('div');
            stm.className = 'marker -marker-highlighted in-search-results mapboxgl-marker';
            new mapboxgl.Marker(stm).setLngLat(this.coordinates[0]).addTo(this.map);
        }

        this.map.addControl(new mapboxgl.NavigationControl({
            showCompass: false,
        }));
        
        this.mapResize();
    }

    mapResize() {
        const resize = setInterval(() => {
            this.map.resize();
        }, 10);
        setTimeout(() => {
            clearInterval(resize);
        }, 1000);
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("mapBox", (coords, zoom) => new MapBox(coords, zoom));
});